import { AnyOperationLogEntityVersion, OperationData } from '@uploadcam/common';
import { addDoc, CollectionReference, Timestamp } from 'firebase/firestore';
import { GetCredentialInteractor } from '../../../auth/domain/interactors/get-credential.interactor';
import { GetUserInteractor } from '../../../auth/domain/interactors/get-user.interactor';
import { DeleteOperationLogInteractor } from './delete-operation-log.interactor';
import { SetOperationLogStateInteractor } from './set-operation-log-state.interactor';
import { OperationLog } from '../models/operation-log';

export class CreateOperationLogInteractor {
  constructor(
    private readonly collection: CollectionReference<AnyOperationLogEntityVersion>,
    private readonly getCredential: GetCredentialInteractor,
    private readonly getUser: GetUserInteractor,
    private readonly deleteOperationLog: DeleteOperationLogInteractor,
    private readonly setOperationLogState: SetOperationLogStateInteractor,
  ) {}

  public async execute<T extends OperationData>(operation: T): Promise<OperationLog<T['type']>> {
    const credential = this.getCredential.execute();
    const user = await this.getUser.execute();

    const doc = await addDoc(this.collection, {
      _version: 0,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
      operation,
      teamId: user.teamId,
      userId: user.id,
      userAuthType: credential.authType,
      userProvider: credential.provider,
      userScopes: credential.scopes,
    });

    return new OperationLog(
      doc.id,
      operation.type,
      this.deleteOperationLog,
      this.setOperationLogState,
    );
  }
}
